
export enum AuthorizeStatusEnum {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error'
}

export enum ProFileStatus {
  started = 'started',
  finished = 'finished'
}

export interface IUserBindPlatformParams{
  type: string | string[];
  code: string | string[];
  state:string | string[];
}

export interface IGetBindInfoParams extends IUserBindPlatformParams{
  installation_id?: string | string[];
}
